export { MessageTypeId, ChildStatus, MESSAGE_TYPE_IDS } from './types';
export type { TimelineEntry, MessageTypeRegistration } from './types';

import { activityRegistration } from 'src/pages/Conversations/Chat/ActivityMessage/registration';
import { chatMessageRegistration } from 'src/pages/Conversations/Chat/ChatMessage/registration';
import { signalIncidentRegistration } from 'src/pages/Conversations/Chat/SignalIncident/registration';
import { triageRunRegistration } from 'src/pages/Conversations/Chat/TriageRun/registration';
import { MessageTypeId, MessageTypeRegistration } from './types';

// MessageTypeRegistration is generic in TItem; ComponentType<{ item: TItem }> is
// contravariant in TItem, so a registration with a specific item type isn't a
// structural subtype of MessageTypeRegistration<unknown>. We accept that mismatch
// once at the registry literal via a double-cast, then consumers see the
// type-erased MessageTypeRegistration<unknown> without any unsafe `any` calls.
type ErasedRegistration = MessageTypeRegistration<unknown>;

export const messageRegistry: Partial<Record<MessageTypeId, ErasedRegistration>> = {
  [MessageTypeId.ChatMessage]: chatMessageRegistration as unknown as ErasedRegistration,
  [MessageTypeId.SignalIncident]: signalIncidentRegistration as unknown as ErasedRegistration,
  [MessageTypeId.Activity]: activityRegistration as unknown as ErasedRegistration,
  [MessageTypeId.TriageRun]: triageRunRegistration as unknown as ErasedRegistration,
};
